<app-title-section></app-title-section>

<div class="card pb-1 " style="margin-left: 15px;margin-bottom: 15px; margin-right: 15px" *ngFor="let warehouse of warehouses">
    <div class="card-body ">
        <div class="mb-1 d-flex justify-content-between align-items-center flex-wrap">
            <h4 class="mb-0">{{ warehouse.nom }}<ng-container *ngIf="warehouse.code || warehouse.code_entrepot"> - {{ warehouse.code || warehouse.code_entrepot }}</ng-container></h4>
            <div class="d-flex align-items-center">
                <ng-container>
                    <button class="btn btn-primary" (click)="onClick(warehouse.id)">
                        Etat de stock
                    </button>
                    <button class="mx-1 bouttonStyle" (click)="openResetModal(warehouse.id)">

                           <i data-feather="rotate-ccw" [size]="18"></i>
                    </button>
                    <button class="bouttonStyle" (click)="openEditModal(warehouse)">

                           <i data-feather="edit" [size]="18"></i>
                    </button>
                </ng-container>
            </div>
        </div>
       <div>
        <label class="size15">  Valeur en stock</label>
       </div>
        <div class="mb-2">
        <label class="size32">  {{ warehouse.stockValue ?? '---' }}  TND</label>
       </div>

        <div class="items styleBorder">

            <div class="row align-content-center mx-1" >
                <div class="iconDesing">
                <i data-feather="align-justify"  [size]="16"></i>
                </div>
                <div>
                    <label  class="mx-1 size152" >Référence  : </label>
                    <label class="size152 text-muted" > {{warehouse.id}}</label>
                </div>

            </div>
            <div class="row align-content-center mx-1" >
                <div class="iconDesing2">
                <i data-feather="map"  [size]="16"></i>
                </div>
                <div>
                    <label  class="mx-1 size152" >Adresse    : </label>
                    <label class="size152 text-muted" > {{ warehouse.adresse }}, {{ warehouse.ville }}, {{ warehouse.code_postal }}, {{ warehouse.pays }}</label>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Add (warehouseSaved) event listener -->
<app-edit-warehouse
    #editWarehouse
    (warehouseSaved)="onWarehouseSaved()">
</app-edit-warehouse>

<app-reset-stock #resetStock (stockReset)="onStockReset()"></app-reset-stock>
<!--
<app-edit-warehouse
        *ngIf="showEdit"
        [warehouse]="warehouse"
        (save)="updateWarehouse($event)"
        (cancel)="showEdit = false">
</app-edit-warehouse>-->